module.exports = __webpack_public_path__ + "img/Bead Road.7bb47301.png";